import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { GetQuery, PostQuery } from './Shared';

interface JobScheduleReOpenProps {
    scheduleId: number;
    showModal: boolean;
    hideModal(): void;
    saveModal(): void;
}

interface FinalInvoice {
    invoiceNumber: number;
    customer: string;
    reckonInvoiceNumber: string;
    amountFormatted: string;
    items: FinalInvoiceItems[];
}

interface FinalInvoiceItems {
    invoiceItemId: number;
    item: string;
    description: string;
    hireStartFormatted: string;
    hireEndFormatted: string;
    amountFormatted: string;
}

const JobScheduleReOpenPopup = (props: JobScheduleReOpenProps) => {
    var initFinalInvoice: FinalInvoice = {
        invoiceNumber: 0,
        customer: "",
        reckonInvoiceNumber: "",
        amountFormatted: "$0.00",
        items: []
    };

    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [typeId, setTypeId] = React.useState(0);   //1 = Install, 2 = Pickup
    const [item, setItem] = React.useState("");
    const [existScheduleDateFormatted, setExistScheduleDate] = React.useState("");
    const [existOnOffHireDateFormatted, setExistOnOffHireDate] = React.useState("");
    const [newScheduleDate, setNewScheduleDate] = React.useState("");
    const [newOnOffHireDate, setNewOnOffHireDate] = React.useState("");
    const [reopenType, setReopenType] = React.useState(1);      //1 = Reschedule, 0 = Cancel (Pickups Only)
    const [cancelFinalInvoice, setCancelFinalInvoice] = React.useState(-1);      //Pickups Only (if Final Inv exists) - 0 = No, 1 = Yes
    const [finalInvoice, setFinalInvoice] = React.useState<FinalInvoice>(initFinalInvoice);
    const [reason, setReason] = React.useState("");

    React.useEffect(() => {
        if (props.showModal && props.scheduleId > 0) {
            getData();
        }
    }, [props.scheduleId]);

    const getData = async () => {
        const apiUrl = 'GetScheduleReOpenDetails?ScheduleId=' + props.scheduleId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setTypeId(result.data.typeId);
            setItem(result.data.item);
            setExistScheduleDate(result.data.existScheduleDateFormatted);
            setExistOnOffHireDate(result.data.existOnOffHireDateFormatted);
            setFinalInvoice(result.data.finalInvoice);
            setLoading(false);
        }
    }

    const hideModal = () => {
        //reset screen and hide
        resetScreen();
        props.hideModal();
    }

    const resetScreen = () => {
        setTypeId(0);
        setExistScheduleDate("");
        setExistOnOffHireDate("");
        setNewScheduleDate("");
        setNewOnOffHireDate("");
        setReopenType(1);
        setCancelFinalInvoice(0);
    }

    const clearError = (e: any) => {
        var error = errors;
        if (e.target.value) {
            delete error[e.target.name];
            setErrors(error);
        }
    }

    const handleReOpenChange = (e: any) => {
        clearError(e);
        var value = e.target.value * 1;
        setReopenType(value);
    }

    const handleDateChange = (e: any) => {
        clearError(e);

        setNewScheduleDate(e.target.value);
    }

    const handleOnOffHireChange = (e: any) => {
        clearError(e);

        setNewOnOffHireDate(e.target.value);
    }

    const handleCancelInvoiceChange = (e: any) => {
        clearError(e);

        setCancelFinalInvoice(e.target.value);
    }

    const handleReasonChange = (e: any) => {
        clearError(e);

        setReason(e.target.value);
    }

    const validate = () => {
        let error: any = {};
        let formIsValid = true;

        if (reopenType === 1) {
            if (!newScheduleDate) {
                formIsValid = false;
                error["newScheduleDate"] = "New Schedule Date is required!";
            }

            if (!newOnOffHireDate) {
                formIsValid = false;
                error["newOnOffHireDate"] = typeId === 1 ? "New On Hire Date is required!" : "New Off Hire Date is required!";
            }
        }


        //if (typeId === 2) {
        //    if (cancelFinalInvoice <= 0) {
        //        formIsValid = false;
        //        error["cancelFinalInvoice"] = "Cancel Final Invoice is required!";
        //    } 
        //} 

        if (!reason || reason.trim() === "") {
            formIsValid = false;
            error["reason"] = "Reason for re-opening is required!";
        }

        setErrors(error);

        return formIsValid;
    }

    const save = () => {
        if (validate()) {
            saveReopenItem();
        } else {
            toast.error("Fix errors on screen before saving!");
        }
    }

    const saveReopenItem = async () => {
        var reOpenDetails = {
            scheduleId: props.scheduleId,
            newScheduleDate: newScheduleDate,
            newOnOffHireDate: newOnOffHireDate,
            reOpenType: reopenType,
            reason: reason
        };

        var jsonItem = JSON.stringify(reOpenDetails);

        const apiUrl = "SaveReOpenItem";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            resetScreen();
            props.saveModal();
        }
    }

    const renderDetails = (
        <Modal show={props.showModal} onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Re-open {item}</Modal.Title>
                <button type="button" className="close modal__close--colour" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <label className="input-group" htmlFor="existScheduleDate">
                    <span className="label">Exist Schedule Date</span>
                    <div>{existScheduleDateFormatted}</div>
                </label>
                <label className="input-group" htmlFor="existOnOffHireDate">
                    <span className="label">Exist {typeId === 1 ? "On Hire Date" : "Off Hire Date"}</span>
                    <div>{existOnOffHireDateFormatted}</div>
                </label>

                <label className={typeId === 1 ? "hidden" : "input-group makeitflexspacebetween alignitemscentre"} htmlFor="reopenType">
                    <input type="radio" id="yes" name="reopenType" value={1} checked={reopenType === 1} onChange={(e) => handleReOpenChange(e)}></input>
                    <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Reschedule Pickup</span>
                    <input type="radio" id="no" name="reopenType" value={0} checked={reopenType === 0} onChange={(e) => handleReOpenChange(e)}></input>
                    <span className="makeitflex makeitcentervertical marginLeft10">Cancel Pickup</span>
                </label>

                <div className={reopenType === 1 ? "" : "hidden" }>
                    <label className="input-group" htmlFor="newScheduleDate">
                        <span className="label">New Schedule Date </span>
                        <input className="input" type="date" id="newScheduleDate" name="newScheduleDate" value={newScheduleDate} onChange={(e) => handleDateChange(e)}></input>
                    </label>
                    <span className="label errors marginLeftLabel">{errors["newScheduleDate"]}</span>

                    <label className="input-group" htmlFor="newOnOffHireDate">
                        <span className="label">New {typeId === 1 ? "On Hire Date" : "Off Hire Date"} </span>
                        <input className="input" type="date" id="newOnOffHireDate" name="newOnOffHireDate" value={newOnOffHireDate} onChange={(e) => handleOnOffHireChange(e)}></input>
                    </label>
                    <span className="label errors marginLeftLabel">{errors["newOnOffHireDate"]}</span>
                </div>

                {/*<label className={typeId === 1 ? "hidden" : "input-group makeitflexspacebetween alignitemscentre"} htmlFor="cancelFinalInvoice">*/}
                {/*    <input type="radio" id="yes" name="cancelFinalInvoice" value={1} checked={cancelFinalInvoice === 1} onChange={(e) => handleCancelInvoiceChange(e)}></input>*/}
                {/*    <span className="makeitflex makeitcentervertical marginLeft10 marginRight10">Yes</span>*/}
                {/*    <input type="radio" id="no" name="cancelFinalInvoice" value={0} checked={cancelFinalInvoice === 0} onChange={(e) => handleCancelInvoiceChange(e)}></input>*/}
                {/*    <span className="makeitflex makeitcentervertical marginLeft10">No</span>*/}
                {/*</label>*/}
                {/*<span className={errors["cancelFinalInvoice"] ? "label errors marginLeftLabel" : "hidden"}>{errors["cancelFinalInvoice"]}</span>*/}
                {/*<div className={typeId === 2 && cancelFinalInvoice === 1 ? "makeitred" : "hidden"}>NOTE: You MUST CREDIT the Invoice in Reckon</div>*/}

                {/*<div className={typeId === 1 ? "hidden" : "" }>*/}

                {/*</div>*/}

                <label className="input-group" htmlFor="reason">
                    <span className="label">Reason for re-opening</span>
                    <textarea className="input allocate__teamnotes" id="reason" name="reason" value={reason} onChange={(e) => handleReasonChange(e)}></textarea>
                </label>
                <span className={errors["reason"] ? "label errors" : "hidden"}>{errors["reason"]}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className="popup-button--yes" onClick={save}>Save</button>
            </Modal.Footer>
        </Modal>
    )

    let contents = !props.showModal ? "" :
        loading ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
}

export default JobScheduleReOpenPopup;